export function isRecord(
  input: unknown
): input is Record<PropertyKey, unknown> {
  return typeof input === "object" && input !== null;
}
